import { useAuth0 } from "@auth0/auth0-react";
import { Autocomplete, Button, Checkbox, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { ArrowLeft, Search, X } from "react-feather";
import { toast } from "react-smart-toaster";
import Loader from "../../../components/Loader";
import styles from "../smartdevices.module.css";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useContext } from "react";
import { JobContext } from "../../../context/JobContext";

const schema = yup.object().shape({
    card_type_new: yup.string().required("This field is Required"),
    card_id: yup.object().when('card_type_new', (card_type_new) => {
        if (card_type_new && (card_type_new === "Existing")) return yup.object().required('This field is Required').nullable();
        return yup.object().nullable();
    }),
    card_type: yup.string().when('card_type_new', (card_type_new) => {
        if (card_type_new && (card_type_new === "New")) return yup.string().required('This field is Required');
        return yup.string();
    }),
    card_number: yup.string().when('card_type_new', (card_type_new) => {
        if (card_type_new && (card_type_new === "New")) return yup.string().required('This field is Required');
        return yup.string();
    }),
    card_name: yup.string().when(['card_type_new', 'card_type'], (card_type_new, card_type) => {
        if (card_type_new && (card_type_new === "Existing")) return yup.string();
        else if (card_type && (card_type === "Tenant" || card_type === "User")) return yup.string();
        return yup.string().required('This field is Required');
    }),
    tenant_info_id: yup.object().when('card_type', (card_type) => {
        if (card_type && (card_type === "Tenant")) return yup.object().required('This field is Required').nullable();
        else return yup.object().nullable();
    }),
    user_id: yup.object().when('card_type', (card_type) => {
        if (card_type && (card_type === "User")) return yup.object().required('This field is Required').nullable();
        else return yup.object().nullable();
    })
});

const AddLockKeyFobForm = ({ setShowAddFormKeyFob, setSnackbarMsg, setSnackbarOpen, onSubmitLocal }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(true);
    const [lockList, setLockList] = useState([]);
    const [allLockList, setAllLockList] = useState([]);
    const [cuurentStep, setCuurentStep] = useState(1);
    const [searchKey, setSearchKey] = useState("");
    const [selectProperty, setSelectProperty] = useState("");
    const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [cardType, setCardType] = useState("");
    const [cardTypeNew, setCardTypeNew] = useState("");
    const [selectedProperty, setSelectedProperty] = useState(0);
    const [tenantList, setTenantList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [keyfobList, setKeyfobList] = useState([]);

    const { setJobId, setProgress, setJobData } = useContext(JobContext);

    const { handleSubmit, control, setValue, errors, clearErrors, setError } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const fetchDeviceList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/device-lock-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setLoading(false);
                setAllLockList(response.data.data);
            }).catch((error) => {
                setLoading(false);
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        fetchDeviceList();
    }, [getAccessTokenSilently]);

    useEffect(() => {

        if (allLockList.length) {
            let tempDeviceList = allLockList;

            if (searchKey !== '') {
                let inputVal = searchKey;
                inputVal = inputVal.toLowerCase();

                tempDeviceList = tempDeviceList.filter((item) => {
                    return (item?.name?.toLowerCase().includes(inputVal) || item?.real_name?.toLowerCase().includes(inputVal));
                });
            }

            if (selectProperty !== "" && selectProperty !== "all") {
                tempDeviceList = tempDeviceList.filter((i) => i.property_id === selectProperty);
            }


            setLockList(tempDeviceList);
        } else {
            setLockList([]);
        }
    }, [allLockList, searchKey, selectProperty]);

    useEffect(() => {
        if (selectedDevices.length > 0) {
            setSelectedProperty(selectedDevices[0]?.property_id);
        }
    }, [selectedDevices]);

    useEffect(() => {
        const fetchTenantList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/tenant-list-property/" + selectedProperty, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setTenantList(response.data.data);
            }).catch((error) => {
                setLoading(false);
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };

        if (cuurentStep === 2 && selectedProperty) {
            fetchTenantList();
        }
    }, [cuurentStep, selectedProperty, getAccessTokenSilently]);

    useEffect(() => {
        const fetchUserList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/user-list-property/" + selectedProperty, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setUserList(response.data.data);
            }).catch((error) => {
                setLoading(false);
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };

        if (cuurentStep === 2 && selectedProperty) {
            fetchUserList();
        }
    }, [cuurentStep, selectedProperty, getAccessTokenSilently]);

    useEffect(() => {
        const fetchKeyFobs = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                let keyFobListTemp = response.data.data?.map(i => {
                    return { id: i?.group_id, label: i?.card_name + " - " + i?.card_number };
                });

                setKeyfobList(keyFobListTemp);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        if (cuurentStep === 2) {
            fetchKeyFobs();
        }
    }, [getAccessTokenSilently, cuurentStep]);

    const onSubmit = async (data) => {
        if (selectedDeviceIds.length === 0) {
            toast.error('Please select device.');
            return false;
        }

        let postData = { devices: selectedDeviceIds };

        if (data?.card_type_new === 'Existing') {
            postData = { ...postData, card_id: data?.card_id?.id };
        } else {
            postData = { ...postData, card_number: data.card_number };
            if (data?.card_type === 'Tenant') {
                postData = { ...postData, card_name: data?.tenant_info_id?.label, tenant_info_id: data?.tenant_info_id?.id };
            } else if (data?.card_type === 'User') {
                postData = { ...postData, card_name: data?.user_id?.label, user_id: data?.user_id?.id };
            } else {
                postData = { ...postData, card_name: data?.card_name };
            }
        }

        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs-new", postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setShowAddFormKeyFob(false);

            setJobId(response?.data?.data?.id);
            setProgress(0);
            setJobData(response?.data?.data);
            /*setLoading(false);
            setShowAddFormKeyFob(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            onSubmitLocal(response.data.data);*/
        }).catch((error) => {
            setLoading(false);
            if (error.response.status === 422) {
                setError("card_number", {
                    type: "validation",
                    message: error.response.data.message
                });

                return false;
            }
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<>
        {loading && <Loader />}
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setShowAddFormKeyFob(false)}><ArrowLeft /></button>
            Add Key Fob
            <button onClick={(e) => setShowAddFormKeyFob(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
            {cuurentStep === 1 && <div className={`${styles.ModalFormGroup}`}>
                <div className={`${styles.AddDeviceSec}`}>
                    <div className={`${styles.SearchConSec}`}>
                        <Search />
                        <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Property*"
                                onChange={(e) => setSelectProperty(e.target.value)}
                            >
                                <MenuItem value="all">All</MenuItem>
                                {propertyList?.map((i) => {
                                    return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
                                })}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>
                <div className={`${styles.AddDeviceRow}`}>
                    {lockList?.map((item, index) => {
                        return (<div className={`${styles.AddDeviceList}`}>
                            <div className={`${styles.AddDeviceListUnder}`}>
                                <div className={`${styles.AddDeviceListHeadSec}`}>
                                    <div className={`${styles.AddDeviceListIconSec}`}>
                                        <img src="/static/img/Door.svg" width="24px" height="24px" alt="" />
                                    </div>
                                    <div className={`${styles.AddDeviceListTitleSec}`}>
                                        <p className={`${styles.AddDeviceListTitleFirst}`}>Door Lock - <span>{item.apartment ? item.apartment.apt_no.slice(5) : item?.apt_text}</span></p>
                                        <p className={`${styles.AddDeviceListTitle}`}>{item?.real_name}</p>
                                    </div>
                                </div>
                                <div className={`${styles.ProspectCardFootSec} KeyFobChecklist`}>
                                    <div className={`${styles.CustomCheck} CustomCheck`}>
                                        <FormControlLabel style={{ margin: "0" }} control={
                                            <Checkbox
                                                onClick={(e) => { e.stopPropagation(); }}
                                                name={"id" + item?.deviceID}
                                                checked={selectedDeviceIds.indexOf(item?.deviceID) > -1}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedDeviceIds(prev => {
                                                            return prev.concat([item?.deviceID]);
                                                        });

                                                        setSelectedDevices(prev => {
                                                            return prev.concat([item]);
                                                        });
                                                    } else {
                                                        setSelectedDeviceIds(prev => {
                                                            return prev.filter(i => i !== item?.deviceID);
                                                        });

                                                        setSelectedDevices(prev => {
                                                            return prev.filter(i => i?.deviceID !== item?.deviceID);
                                                        });
                                                    }
                                                }}
                                            />
                                        } />
                                    </div>
                                </div>
                            </div>
                        </div>);
                    })}
                </div>
                <div className={`${styles.ButtonAction}`}>
                    <Button className="CancelPopupBU" onClick={(e) => setShowAddFormKeyFob(false)}>Cancel</Button>
                    <Button className="SubmitPopupBU" onClick={(e) => {
                        if (selectedDeviceIds.length === 0) {
                            toast.error('Please select device.');
                            return false;
                        }
                        setCuurentStep(2);
                    }}>Next</Button>
                </div>
            </div>}

            {cuurentStep === 2 && <div className={`${styles.ModalFormGroupTwo}`}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={`${styles.AddDeviceFormTwo}`}>
                        <div className={`${styles.AddDeviceFormRow}`}>
                            <p className={`${styles.AddDeviceFormTitle}`}>Card Details</p>
                            <div className={`${styles.OneThirdSec} ${styles.Half} FormGroup AddDevice`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Status*</InputLabel>
                                    <Controller
                                        name="card_type_new"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Type*"
                                                onChange={(e) => {
                                                    field.onChange(e);

                                                    setCardTypeNew(e.target.value);
                                                    setCardType("");
                                                    setValue("card_type", "");
                                                    clearErrors();
                                                }}
                                            >
                                                <MenuItem value="Existing">Existing</MenuItem>
                                                <MenuItem value="New">New</MenuItem>
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors?.card_type_new && (<p className={`${styles.ErrorM}`}>{errors?.card_type_new?.message}</p>)}
                            </div>
                            {cardTypeNew === 'Existing' && <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="card_id"
                                        control={control}
                                        render={(field) => (<Autocomplete
                                            id="free-solo-2-demo"
                                            disableClearable
                                            options={keyfobList}
                                            renderInput={(params) => (<TextField {...params} label="Select Keyfob*" />)}
                                            onChange={(event, newValue) => {
                                                setValue('card_id', newValue);
                                                clearErrors();
                                            }}
                                        />)}
                                    />
                                </FormControl>
                                {errors?.card_id && (<p className={`${styles.ErrorM}`}>{errors?.card_id?.message}</p>)}
                            </div>}
                            {cardTypeNew === 'New' && <>
                                <div className={`${styles.OneThirdSec} ${styles.Half} FormGroup AddDevice`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                                        <Controller
                                            name="card_type"
                                            control={control}
                                            render={(field) => (
                                                <Select
                                                    {...field}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Type*"
                                                    onChange={(e) => {
                                                        field.onChange(e);

                                                        setCardType(e.target.value);
                                                    }}
                                                >
                                                    <MenuItem value="Tenant">Tenant</MenuItem>
                                                    <MenuItem value="User">User</MenuItem>
                                                    <MenuItem value="Other">Other</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                    {errors?.card_type && (<p className={`${styles.ErrorM}`}>{errors?.card_type?.message}</p>)}
                                </div>
                                {(cardType !== 'Tenant' && cardType !== 'User') && <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="card_name"
                                            control={control}
                                            render={(field) => (
                                                <TextField
                                                    {...field}
                                                    id="outlined-multiline-static"
                                                    label="Card Name*"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    {errors?.card_name && (<p className={`${styles.ErrorM}`}>{errors?.card_name?.message}</p>)}
                                </div>}
                                {cardType === 'Tenant' && <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="tenant_info_id"
                                            control={control}
                                            render={(field) => (<Autocomplete
                                                id="free-solo-2-demo"
                                                disableClearable
                                                options={tenantList}
                                                renderInput={(params) => (<TextField {...params} label="Tenant*" />)}
                                                onChange={(event, newValue) => {
                                                    setValue('tenant_info_id', newValue);
                                                    clearErrors();
                                                }}
                                            />)}
                                        />
                                    </FormControl>
                                    {errors?.tenant_info_id && (<p className={`${styles.ErrorM}`}>{errors?.tenant_info_id?.message}</p>)}
                                </div>}
                                {cardType === 'User' && <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="user_id"
                                            control={control}
                                            render={(field) => (<Autocomplete
                                                id="free-solo-2-demo"
                                                disableClearable
                                                options={userList}
                                                renderInput={(params) => (<TextField {...params} label="User*" />)}
                                                onChange={(event, newValue) => {
                                                    setValue('user_id', newValue);
                                                    clearErrors();
                                                }}
                                            />)}
                                        />
                                    </FormControl>
                                    {errors?.user_id && (<p className={`${styles.ErrorM}`}>{errors?.user_id?.message}</p>)}
                                </div>}
                                <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="card_number"
                                            control={control}
                                            render={(field) => (
                                                <TextField
                                                    {...field}
                                                    id="outlined-multiline-static"
                                                    label="Card Number*"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    {errors?.card_number && (<p className={`${styles.ErrorM}`}>{errors?.card_number?.message}</p>)}
                                </div>
                            </>}
                        </div>
                    </div>
                    <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>
                    <ul className={`${styles.SelectedDeviceList}`}>
                        {selectedDevices?.map((item, index) => {
                            return (<li key={index}>
                                <img src="/static/img/Door.svg" width="24px" height="24px" alt="" />
                                <p>{item?.real_name} / {item.apartment ? item.apartment.apt_no : item.apt_text}</p>
                            </li>)
                        })}
                    </ul>
                    <div className={`${styles.ButtonAction}`}>
                        <Button onClick={(e) => setCuurentStep(1)} className="CancelPopupBU">Back</Button>
                        <Button className="SubmitPopupBU" type="submit">Add</Button>
                    </div>
                </form>
            </div >}
        </DialogContent >
    </>);
}

export default AddLockKeyFobForm;